<template>
  <div>
    <!-- 渲染html -->
    <div class="wrapClass">
      <!-- 头部 -->
      <div class="UCenter-bg">
        <!-- 原生视频全屏播放 -->
        <video id='my-video' ref="video" :src="videoUrl" @click="player" autoplay="auto" preload controls loop webkit-playsinline='true' playsinline='true' x-webkit-airplay='true' x5-video-player-type='h5'  x5-video-player-fullscreen='true' x5-video-ignore-metadata='true' width='100%' height='100%'
        :style="{'background-size':'cover','background-repeat':'no-repeat','background-image':'url(' + videoUrl  + ')'}"
        >
          <source :src="videoUrl" type="video/mp4">
          <source :src="videoUrl" type="video/ogg">
          <source :src="videoUrl" type="video/webm">
        </video>
        <div class="nav_logo">
            <img src="../assets/logo.png" class="logo"/>
          </div>
        <div class="nav_box">
          <div class="down_box">
            <span class="down_btn" @click="isDown">
              开始制作
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Base64 } from "js-base64";
// import wx from "weixin-js-sdk";
import Icon from "vant/lib/icon";
import Dialog from "vant/lib/dialog";
import Search from "vant/lib/search";
import List from "vant/lib/list";
import Button from "vant/lib/button";
import Cell from "vant/lib/cell";
import Popup from "vant/lib/popup";

import "vant/lib/icon/style";
import "vant/lib/dialog/style";
import "vant/lib/search/style";
import "vant/lib/list/style";
import "vant/lib/button/style";
import "vant/lib/cell/style";
import "vant/lib/popup/style";
export default {
  components: {
    "van-popup": Popup,
    "van-icon": Icon,
    "van-dialog": Dialog,
    "van-search": Search,
    "van-list": List,
    "van-cell": Cell,
    "van-button": Button
  },

  data() {
    return {
      data: null,
      isIos: false,
      isAndroid: false,
      schemeUrl: "",
      downloadUrl: "",
      autoplay:true,
      videoUrl:"",
      video:""
    };
  },
  watch: {},
  created() {
    
  },

  mounted() {

    let url = this.$route.query.s; //获取需要的值
    this.videoUrl = Base64.decode(url); //解码

    this.$nextTick(() => {
        const video = document.getElementById('my-video')
        // 一般情况下，这样就可以自动播放了，但是一些奇葩iPhone机不可以
        video.play()
        // 必须在微信Weixin JSAPI的WeixinJSBridgeReady才能生效
        document.addEventListener('WeixinJSBridgeReady', () => {
          video.play()
          video.removeAttribute('muted');
        },false)
      })

    // this.video = this.$refs.video;
    // this.video.play();
    // document.getElementById('my-video').play();
    //在play之后加一个延时，清除video的muted属性
    // setTimeout(function(){
    //     this.$refs.video.removeAttribute('muted');
    // }, 100);
    // this.loadData();
  },
  activated() {
    // this.init();
  },
  deactivated() {
    this.unbind();
  },
  methods: {
    //截取某个字符前面或者后面的字符串
    getStr(string,str){ 
        var str_before = string.split(str)[0]; //前
        var str_after = string.split(str)[1]; //后
        
    },
    init() {
      let videoEl = this.$refs.video;
      // videoEl.currentTime = 0;
      videoEl.addEventListener("loadstart", this.loadStart);
      videoEl.addEventListener("canplay", this.canPlay);
      videoEl.addEventListener("playing", this.playing);
      videoEl.addEventListener("pause", this.pause);
      videoEl.addEventListener("waiting", this.waiting);
      videoEl.addEventListener("ended", this.ended);
    },
    unbind() {
      let videoEl = this.$refs.video;
      videoEl.removeEventListener("loadstart", this.loadStart);
      videoEl.removeEventListener("canplay", this.canPlay);
      videoEl.removeEventListener("playing", this.playing);
      videoEl.removeEventListener("pause", this.pause);
      videoEl.removeEventListener("waiting", this.waiting);
      videoEl.removeEventListener("ended", this.ended);
    },
    //初始化请求
    loadData() {
      let data = {
        clientType: 1,
        deviceType: 1
      };
      const options = {
        method: "POST",
        url: this.$api.getNewVersion,
        data: data
      };
      this.$http(options).then(res => {
        if (res.data.code === 200) {
          this.loading = false;
          let data = res.data.data;
          this.data = data;
          this.schemeUrl = data.url;
          this.downloadUrl = data.url;
        }
      });
    },
    isDown() {
      var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
      let hidden =
          window.document.hidden ||
          window.document.mozHidden ||
          window.document.msHidden ||
          window.document.webkitHidden;
        if (typeof hidden == "undefined" || hidden == false) {
          // button.href="https://a.app.qq.com/o/simple.jsp?pkgname=com.ruanyiit.facefusion"
          // 上面的https是应用地址比如说应用宝，pkgname=应用名称
          window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.ruanyiit.facefusion"; //安卓应用市场地址
        }
    }
    if (isIOS) {
      //ios端
        let hidden =
          window.document.hidden ||
          window.document.mozHidden ||
          window.document.msHidden ||
          window.document.webkitHidden;
        if (typeof hidden == "undefined" || hidden == false) {
          // button.href="https://apps.apple.com/cn/app/你应用的名字/id11646468"
          // 上面的应用后面的id是你上传到appstore后，在App Store Connect的App信息界面会有一个Apple ID。添加到id后面即可。
          window.location.href = "https://baidu.com"; //app store地址
        }
    }
    },
    player(){
            console.log(this.video.clientWidth);
            console.log(this.video.clientHeight);
            if(this.video.paused){
                // 播放
                this.video.play();
            }else{
                // 暂停
                this.video.pause()
            };            
        }

  }
};
</script>

<style scoped>
@import "../assets/iconfont/font_set_read_bar/iconfont.css";
@import "../styles/common.css";
@import "../styles/style.css";
/* 阻止文本复制 */
* {
  -o-user-select: none; /* 设置或检索是否允许用户选中文本 */
  -khtml-user-select: none; /* 苹果浏览器文本选择 */
  -webkit-user-select: none; /* 所有的文本选择 */
  -ms-user-select: none; /*IE浏览器*/
  user-select: none; /*用户是否能够选中文本*/
  -webkit-touch-callout: default; /* 系统默认浏览器长按链接与图片弹出菜单 */
}
.wrap {
  min-height: 100vh;
  /* background-color: white; */
}
.UCenter-bg {
  position: relative;
  left: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  /* display: block; */
}
/* .UCenter-bg img {
  width: 100%;
  height: 100%;
} */
.video{
  width: 100%; 
  height: 100%;
  z-index: 999;
}
#my-video{
  object-fit: cover;
   object-position: center center;
   z-index: 999;
}
.nav_logo{
  position: absolute;
  right: 5%;
  top: 2%;
  width:45px;
  height: 45px;
  z-index: 1002;
}
.nav_logo .logo{
  width:100%;
  height: 100%;
}
.nav_box {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 2%;
  width: 100%;
  z-index: 1002;
}
.flex_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.en_box {
  padding: 0 35px 19px 35px;
  text-align: left;
}
.studytip {
  display: block;
  font-size: 20px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #3f99c4;
  line-height: 28px;
}
.study_title2 {
  display: block;
  font-size: 14px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
}
.study_title3 {
  display: block;
  font-size: 12px;
  color: #959595;
  line-height: 30px;
}
.study_en {
  display: block;
  margin-bottom: 4px;
}
.study_tip {
  display: block;
  font-size: 12px;
  line-height: 20px;
  color: #959595;
}
.update_box {
  padding: 0 35px;
  margin-bottom: 22px;
  text-align: left;
}
.update_box span {
  display: block;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  white-space: pre-wrap;
}
.update_nav {
  height: 80px;
  overflow-y: auto;
}
.down_box {
  padding: 0 3%;
  color: #ffffff;
}
/* to right */
.down_btn {
  display: block;
  height: 44px;
  line-height: 44px;
  background: linear-gradient(96deg, #808DFB 0%, #E968C6 100%);
  border-radius: 5px;
  left: 0;
  bottom: 0;
}

.van-popup {
  min-height: 8%;
  /* box-shadow: 0px -2px 10px #ececec; */
}

.van-slider {
  margin: 0px 10px;
}
.zi-add::after {
  content: "-";
}
.zi-sub::after {
  content: "+";
}

.bold {
  line-height: 36px;
  font-weight: bold;
}
.fontWeight {
  font-weight: bold;
}

.padLR20 {
  padding: 0 20px;
  margin-top: 10px;
}

.van-icon-arrow::before {
  color: rgb(255, 107, 70);
  border-radius: 50%;
  content: "\F00A";
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/view/test.vue